import {getCurrentUserCorpList} from '@/api/corporation/user'

export default {
  methods: {
    judgeLoginUserInfo() {
      return new Promise((resolve, reject) => {
        // 20201126一个用户支持多个企业修改
        getCurrentUserCorpList(true).then(({data}) => {
          if (data.code === 0) {
            this.$store.commit('SET_LOGIN_DATA', data.data)
            // console.info(data.data)
            resolve()
          } else if (data.code === 1200007) {
            reject(new Error('该企业用户不存在！'))
          } else {
            reject(new Error(data.msg))
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/login/judgeUserInfo.js